import { CommonHelper } from "../helpers";
export default {
  setLoanProjections(payload) {
    let p = {};
    p.loanProjectionResult = [];
    for (let i = 0; i < payload.loanProjectionResult.length; i++) {
      let loanInfo = {};
      loanInfo.loanID = payload.loanProjectionResult[i].loanID;
      loanInfo.totalLoanRepayment =
        payload.loanProjectionResult[i].totalLoanRepayments;
      loanInfo.totalInterest = payload.loanProjectionResult[i].totalInterest;
      loanInfo.LoanPaindId = payload.loanProjectionResult[i].loanPaidIn;

      loanInfo.loanProjection = [];
      for (
        let j = 0;
        j < payload.loanProjectionResult[i].loanProjection.length;
        j++
      ) {
        let loanProjection = {};
        loanProjection.year =
          payload.loanProjectionResult[i].loanProjection[j].year;
        loanProjection.financialYear =
          payload.loanProjectionResult[i].loanProjection[j].financialYear;
        loanProjection.openingBalance =
          payload.loanProjectionResult[i].loanProjection[j].openingBalance;
        loanProjection.repaymentSOM =
          payload.loanProjectionResult[i].loanProjection[j].repaymentSOM;
        loanProjection.drawdownSOM =
          payload.loanProjectionResult[i].loanProjection[j].drawdownSOM;
        loanProjection.interestPayable =
          payload.loanProjectionResult[i].loanProjection[j].interestPayable;

        loanProjection.interestOffset =
          payload.loanProjectionResult[i].loanProjection[j].interestOffset;
        loanProjection.offsetBalance =
          payload.loanProjectionResult[i].loanProjection[j].offsetBalance;
        loanProjection.repaymentEOM =
          payload.loanProjectionResult[i].loanProjection[j].repaymentEOM;

        loanProjection.drawdownEOM =
          payload.loanProjectionResult[i].loanProjection[j].drawdownEOM;
        loanProjection.repaymentEOMAuto =
          payload.loanProjectionResult[i].loanProjection[j].repaymentEOMAuto;
        loanProjection.drawdownEOMAuto =
          payload.loanProjectionResult[i].loanProjection[j].drawdownEOMAuto;
        loanProjection.closingBalance =
          payload.loanProjectionResult[i].loanProjection[j].closingBalance;

        loanProjection.interestRate =
          payload.loanProjectionResult[i].loanProjection[j].interestRate;

        loanProjection.repaymentAll =
          payload.loanProjectionResult[i].loanProjection[j].repaymentAll;

        loanProjection.capitalPaid =
          payload.loanProjectionResult[i].loanProjection[j].capitalPaid;
        loanProjection.repaymentCumulative =
          payload.loanProjectionResult[i].loanProjection[j].repaymentCumulative;

        loanProjection.interestPaidCumulative =
          payload.loanProjectionResult[i].loanProjection[
            j
          ].interestPaidCumulative;

        loanProjection.capitalPaidCumulative =
          payload.loanProjectionResult[i].loanProjection[
            j
          ].capitalPaidCumulative;

        loanProjection.remainingLoanTerm =
          payload.loanProjectionResult[i].loanProjection[j].remainingLoanTerm;

        loanInfo.loanProjection.push(loanProjection);
      }
      p.loanProjectionResult.push(loanInfo);
    }
    return p;
  },
  setAreaChartProjections(loanProjection) {
    let areachart = {
      minXAxis: 0,
      maxXAxis: loanProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < loanProjection.length; i++) {
      let openingBalance = loanProjection[i].openingBalance;
      if (areachart.maxYAxis < openingBalance) {
        areachart.maxYAxis = openingBalance;
      }
      if (i == 0)
        this.addAreaChartCoordinate(
          areachart,
          i,
          openingBalance,
          loanProjection[i].interestRate
            ? (loanProjection[i].interestRate * 100).toFixed(2)
            : loanProjection[i].interestRate,
          loanProjection[i].year-1,
          loanProjection.length
        );

      let closingBalance = loanProjection[i].closingBalance;
      if (areachart.maxYAxis < closingBalance) {
        areachart.maxYAxis = closingBalance;
      }
      this.addAreaChartCoordinate(
        areachart,
        i+1 ,
        closingBalance,
        loanProjection[i].interestRate
          ? (loanProjection[i].interestRate * 100).toFixed(2)
          : loanProjection[i].interestRate,
        loanProjection[i].year ,
        loanProjection[i].remainingLoanTerm
      );
    }

    return areachart;
  },

  addAreaChartCoordinate(
    areachart,
    index,
    balance,
    interestRate,
    year,
    remainingLoanTerm
  ) {
    areachart.data.push({
      id: index,
      value: {
        x: index,
        y: balance,
        title: [
          { value: "Year " + parseInt(index), class: "bold-text" },
          { value: "|" },
          {
            value: year,
            class: "bold-text",
          },
        ],
        tooltipText: [
          {
            id: "Loan Remaining",
            value: CommonHelper.convertIntoCurrencyWithoutDecimal(balance),
          },
          {
            id: "Year Remaining",
            value: remainingLoanTerm,
          },
          {
            id: "Effective Interest Rate",
            value: interestRate + "%",
          },
        ],
      },
    });
  },
  setBarChartProjections(loanProjection) {
    let barchart = {
      minXAxis: 0,
      maxXAxis: loanProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < loanProjection.length; i++) {
      let principalAmount = parseFloat(loanProjection[i].capitalPaid);
      if (principalAmount < 0) {
        principalAmount = 0;
      }
      if (
        barchart.maxYAxis <
        principalAmount + loanProjection[i].interestPayable
      ) {
        barchart.maxYAxis = principalAmount + loanProjection[i].interestPayable;
      }
      barchart.data.push({
        id: i,
        title: `Year ${i + 1} | ${loanProjection[i].year }`,
        value: [
          {
            id: "Principal_" + i,
            value: principalAmount,
          },
          {
            id: "Interest_" + i,
            value: loanProjection[i].interestPayable,
          },
        ],
      });
    }
    return barchart;
  },
};
